import { useQueryClient } from '@tanstack/react-query';
import { reportGetters } from '@/reports/reportGetters/reportGetters';
import { Meta } from '@/reports/types/report';
import { useReportRedirect } from '@/reports/useReportRedirect/useReportRedirect';
import { constructClaimedVehicleQueryParam } from '@/utils/index';

export const useRerunVehicleReport = () => {
  const { redirectToReportUrl, location } = useReportRedirect();
  const queryClient = useQueryClient();

  return async (meta: Meta) => {
    const searchMethod = constructClaimedVehicleQueryParam(
      meta?.search_data,
      meta?.search_by as string
    );

    const response = await reportGetters.vehicle({
      queryParams: new URLSearchParams({
        ...searchMethod,
      }),
    });

    // If already on the report we just need to invalidate the query
    if (
      location.pathname === '/report/vehicle' &&
      location.search === `?permalink=${response.report.permalink}`
    ) {
      queryClient.invalidateQueries(['report']);
      return;
    }

    redirectToReportUrl('vehicle', response?.report?.permalink);
  };
};
